// Single source of truth for the API base URL used across the frontend.
//
// Why a runtime resolver instead of `process.env.REACT_APP_BACKEND_URL`?
// CRA inlines env vars at BUILD time. If the production build was generated
// with the preview URL baked in, the live bundle would keep hitting the
// preview backend (cross-origin → CORS). To make the bundle safe regardless
// of the env var value at build time, we resolve the base from the browser's
// current origin:
//   • On any custom/production domain → return "" so requests are SAME-ORIGIN
//     relative paths like "/api/auth/login". The reverse proxy routes them to
//     the backend.
//   • On the Emergent preview sandbox (*.preview.emergentagent.com) and on
//     localhost → fall back to REACT_APP_BACKEND_URL (or empty string) so the
//     existing dev/preview setup keeps working.
const PREVIEW_HOST_REGEX = /\.preview\.emergentagent\.com$/i;

function resolveApiBase() {
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname;
    const isPreview = PREVIEW_HOST_REGEX.test(host);
    const isLocalhost = host === "localhost" || host === "127.0.0.1";
    if (!isPreview && !isLocalhost) {
      // Production custom domain — same-origin, relative paths.
      return "";
    }
  }
  // Preview / dev / SSR fallback.
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const API_BASE = resolveApiBase();
